var map = {
	"./age-verification.svg": "0027",
	"./card.svg": "de3e",
	"./login.svg": "5966",
	"./money.svg": "591c",
	"./pairing.svg": "530e",
	"./printing.svg": "17fc",
	"./sync.svg": "e32b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40b9";